import { Paper, Typography } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

export default function Tipp(props) {

    return(
        <Paper sx={{display: "flex", alignItems: "center", p: {xs: 1, sm: 2}, backgroundColor: "primary.lightest"}}>
            <InfoOutlined fontSize="large"/>
            <Typography>{props.text}</Typography>
        </Paper>
    )
}